import { useEffect } from 'react';
import { prefixes, useTypedTranslation } from "@/locales";

export const usePageTitle = (pageTitle?: string) => {
  const [t] = useTypedTranslation(prefixes('general'));

  useEffect(() => {
    const appName = t('appName');

    if (pageTitle) {
      document.title = `${appName} - ${pageTitle}`;
    } else {
      document.title = appName;
    }
  }, [pageTitle, t]);
};
